import { Backdrop, Box } from "@mui/material";
//import TovFormIcon from "../../assets/images/tovFormAnimatedLogo.gif";
import TovFormIcon from "../../assets/images/tovformfavicon.png";

const ProgressIndicatorView = ({ open }) => {
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={open}

        >
            <Box component="img" className="bouncing-image" src={TovFormIcon} sx={{ width: { xs: 90, md: 150 } }} />
        </Backdrop>
    );
};

export default ProgressIndicatorView;